import React, { Component } from 'react'
import { observer } from 'mobx-react'
import mainStore from '@components/Main/store'
import { getMoney } from '@hlj/hlj-utils'
import {
  INCOME_PATH,
  JIAMENG_GOODS_PATH,
  COLOR_ORANGE,
  ORDER_PATH,
  PRIVILEGE_STORE_SERVICE_ID,
  ACCOUNT_SERVICE_PATH
} from '@constant'
import Numbers from '../Numbers'
import { getAuthId } from '@util'

@observer
export default class extends Component {
  handleData = ({
    sum_balance = 0,
    product_count = 0,
    todo_order_count = 0,
    refund_count = 0,
    supports_count = 0
  }) => {
    const all = [
      {
        id: 1,
        title: '上架商品',
        value: product_count,
        link: JIAMENG_GOODS_PATH
      },
      {
        id: 2,
        title: '待接单',
        value: todo_order_count,
        link: `${ORDER_PATH}/14`,
        color: COLOR_ORANGE
      },
      {
        id: 3,
        title: '待处理退款',
        value: refund_count,
        link: `${ORDER_PATH}/20`,
        color: COLOR_ORANGE
      },
      {
        id: 4,
        title: '员工数',
        value: supports_count,
        link: ACCOUNT_SERVICE_PATH,
        color: COLOR_ORANGE
      },
      {
        id: 5,
        title: '余额',
        value: getMoney(sum_balance),
        link: INCOME_PATH
      }
    ]

    // 客服只有待接单和待处理退款
    if (getAuthId() == PRIVILEGE_STORE_SERVICE_ID) {
      return all.filter(item => item.id === 2 || item.id === 3)
    }
    return all
  }

  render() {
    const { shopInfo } = mainStore
    const data = this.handleData(shopInfo)

    return <Numbers title="店铺" data={data} style={{ marginBottom: 20 }} />
  }
}
